// @flow
import initialState from "./initialState";
import * as ActionTypes from "../actions/actionTypes";

export default function (state: Boolean = initialState.showLoader, action: any) {
    switch (action.type) {
        case ActionTypes.SHOW_LOADING_BAR: 
            return true;
        case ActionTypes.HIDE_LOADING_BAR:
            return false;
        default:
            return state;
    }
}
